export enum Lang {
  DE = "DE",
  EN = "EN",
}
